'use strict';

const isWithinRefElement = (target, elementRef) => {
    if (elementRef && elementRef.current && target) {
        const containerRect = elementRef.current.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        if (targetRect.x >= containerRect.x &&
            targetRect.x + targetRect.width <= containerRect.x + containerRect.width &&
            targetRect.y >= containerRect.y &&
            targetRect.y + targetRect.height <= containerRect.y + containerRect.height) {
            return true;
        }
    }
    return false;
};

exports.isWithinRefElement = isWithinRefElement;
//# sourceMappingURL=dom.js.map
